import { ChevronDown } from 'lucide-react'
import type { FinanceAreaKey } from '@/components/Financeiro/solicitacoes/financeSolicitacoesConfig'
import {
  PORTAL_HUB_ALL_TITLE,
  PORTAL_HUB_AREA_TITLES,
} from '@/components/PortalPj/portalPjAreaHub'

type AreaValue = FinanceAreaKey | 'ALL'

type Props = {
  value: AreaValue
  allowedAreas: FinanceAreaKey[]
  showAllOption?: boolean
  onChange: (area: AreaValue) => void
}

export function PortalPjAreaSelect({ value, allowedAreas, showAllOption, onChange }: Props) {
  return (
    <label className='block'>
      <span className='mb-2 block text-sm font-medium text-white'>
        Entre em contato conosco a respeito de
      </span>
      <div className='relative'>
        <select
          value={value}
          onChange={(e) => onChange(e.target.value as AreaValue)}
          className='w-full appearance-none rounded-xl border border-[#e91e63]/25 bg-[#14072b] py-3 pl-4 pr-10 text-sm font-medium text-white shadow-sm transition-colors focus:border-[#e91e63]/45 focus:outline-none focus:ring-2 focus:ring-[#e91e63]/20'
        >
          {allowedAreas.map((area) => (
            <option key={area} value={area}>
              {PORTAL_HUB_AREA_TITLES[area]}
            </option>
          ))}
          {showAllOption && <option value='ALL'>{PORTAL_HUB_ALL_TITLE}</option>}
        </select>
        <ChevronDown
          size={18}
          className='pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-white/45'
          aria-hidden
        />
      </div>
    </label>
  )
}
